import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  PolicyPaymentItem,
  actionCreators,
  CallState,
  PaymentState,
  CustomerState,
  ErrorItem,
} from "../store/Customer";
import { ApplicationState } from "../store";
import _ from "lodash";
import { CreditCardInput } from "abg-ui-components";
import { Button, Container, Col, Row, Table, Alert } from "reactstrap";
import "./Payment.css";
import config from "../store/config";

interface Actions {
  onClose(): void;
}
type PaymentProps = React.Props<{}> & {
  customer: CustomerState;
  items: PolicyPaymentItem[];
  tx: string;
  paymentState: PaymentState;
  callPaused: CallState;
  success?: boolean;
  failure?: boolean;
  timestamp?: Date;
  message?: string;
  validationErrors: ErrorItem[];
} & typeof actionCreators &
  Actions;

const Payment = (props: PaymentProps) => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<{
    number: string;
    cardType: string;
    cvc: string;
    name: string;
    year: number;
    month: number;
  }>(null);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState(false);
  const [total, setTotal] = useState(0);
  let [errorCount, setErrorCount] = useState(0);

  const {
    success,
    failure,
    timestamp,
    reset,
    pause,
    resume,
    callPaused,
    paymentState,
    customer,
  } = props;

  const getPaymentState = () => paymentState;

  const beforeUnloadListener = useCallback((ev) => {
    ev.preventDefault();
    ev.returnValue =
      "You are in the process of taking payment - please wait until payment is complete or fails.";
    return ev;
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", beforeUnloadListener);

    console.log(props.items);
    if (props.items) {
      const total = _.sumBy(props.items, (x) => x.amount);
      setTotal(total);
    }

    return () => {
      window.removeEventListener("beforeunload", beforeUnloadListener);
    };
  }, []);

  useEffect(() => {
    if (callPaused == CallState.PAUSED) {
      console.log("Call paused");
    } else if (callPaused == CallState.NOT_PAUSED) {
      console.log("Call not paused");
    } else if (callPaused == CallState.PAUSING) {
      console.log("Call pausing....");
    }
  }, [callPaused]);

  useEffect(() => {
    if (paymentState == PaymentState.PAYING) {
      setLoading(true);
    }

    if (paymentState == PaymentState.FAILED) {
      errorCount++;
      setErrorCount(errorCount);
      setLoading(false);
      setError(true);
      setComplete(true);
    }

    if (paymentState == PaymentState.SUCCESS) {
      setLoading(false);
      setError(false);
      setComplete(true);
    }
  }, [reset, paymentState]);

  const onClick = () => {
    setLoading(true);
    setError(false);
    setComplete(false);
    const total = _.sumBy(props.items, (x) => x.amount);
    props.pay(props.items, total, false);
  };

  const onCancel = () => {
    setLoading(false);
    setError(false);
    setComplete(false);
  };

  const onValid = (
    valid: boolean,
    number: string,
    cvc: string,
    month: string,
    year: string,
    name: string,
    issuer: string,
  ) => {
    console.log(`is valid? ${valid} - ${year}`);
    if (valid) {
      setDetails({
        number,
        cardType: issuer,
        cvc,
        name,
        year: parseInt(year) + 2000,
        month: parseInt(month),
      });
    }
  };

  if (
    !complete &&
    (callPaused == CallState.INITIAL || callPaused == CallState.PAUSING)
  ) {
    return <div>Pausing call, please wait.</div>;
  }

  {
    /*Payment Failed*/
  }
  if (complete && error && errorCount == 4) {
    return (
      <div>
        <h2 className="section_title mb-4">Payment Failed</h2>

        <p className="page-details-text">
          Unfortunately we haven't been able to take a card payment; the card
          details you have supplied can't be processed by our card payment
          partner. To ensure your cover stays in place, you can call us on 01603
          218000 during office hours to speak with one of our team and pay over
          the phone.{" "}
        </p>

        {/*<Button onClick={_ => props.onClose()}>Return To Main Screen</Button>*/}
      </div>
    );
  }

  {
    /*Payment Complete*/
  }
  if (complete && !error) {
    setTimeout(() => {
      window.removeEventListener("beforeunload", beforeUnloadListener);
      if (!config.brand || (config.brand && config.brand) == "abg")
        window.location.href = "https://www.alanboswell.com/";
      if (config.brand && config.brand == "stech")
        window.location.href = "https://www.s-tech.co.uk/";
    }, 10000);

    return (
      <div>
        <h2 className="section_title mb-4">Successful Payment</h2>

        <p className="page-details-text">
          Thank you for your payment of &pound;
          {_.sumBy(props.items, (x) => x.amount).toFixed(2)}. We will send you
          an email confirmation shortly.
        </p>

        {/*<Button onClick={_ => props.onClose()}>Return To Main Screen</Button>*/}
      </div>
    );
  }

  return (
    <div>
      <div className="pay-summary-container">
        <Row>
          <Col>
            <div className="pay-summary-section">
              <div className="pay-summary">
                <h4 className="title">Your order</h4>

                <div className="pay-summary-list-item">
                  <div>
                    Your Customer Reference -{" "}
                    {customer.branch +
                      "/" +
                      customer.clientRef +
                      customer.policyRef}
                  </div>
                  {/*<div>&pound;{_.sumBy(props.items, x => x.amount).toFixed(2)}</div>*/}
                </div>
              </div>
              <div className="total-to-pay">
                <div>Total to pay</div>
                <div>
                  &pound;{_.sumBy(props.items, (x) => x.amount).toFixed(2)}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <br />
      <br />
      <CreditCardInput
        amount={total}
        loading={loading}
        onClick={onClick}
        onCancel={onCancel}
        focus
        onValid={onValid}
        error={props.message}
      ></CreditCardInput>
      <br />
      <br />
      {/*paymentState !== PaymentState.PAYING && <Button onClick={_ => { props.onClose(); }}>Cancel</Button>*/}
      <br />
      <br />
    </div>
  );
};

export default connect(
  (state: ApplicationState) => ({
    customer: state.customer,
    items: state.customer.policies,
    paymentState: state.customer.paymentState,
    callPaused: state.customer.callPaused,
    tx: state.customer.transactionCode,
    timestamp: state.customer.paymentTimestamp,
    success: state.customer.paymentSuccess,
    failure: state.customer.paymentFailure,
    message: state.customer.message,
    validationErrors: state.customer.validationErrors,
  }),
  actionCreators,
)(Payment);
